export const buildQueryParams = (filters, page, perPage, warehouseId) => {
  const params = { page, per_page: perPage }
  if (warehouseId) {
    params.warehouse_id = warehouseId
  }
  if (filters.onlyPending) {
    params.acknowledged = false
  }
  if (filters.carrier) {
    params.carrier_name = filters.carrier
  }
  // Backend rule: pass both or neither (passing only one returns 422).
  if (filters.dateFrom && filters.dateTo) {
    params["created_at[from]"] = filters.dateFrom.toISOString()
    params["created_at[to]"] = filters.dateTo.toISOString()
  }
  return params
}

export const parseResponseBody = (metadata, errorMessage) => {
  if (!metadata || Object.keys(metadata).length === 0) {
    return { mode: "fallback", content: errorMessage }
  }
  const body = metadata.response_body
  if (typeof body === "object" && body !== null) {
    return { mode: "json", content: body }
  }
  if (typeof body === "string") {
    try {
      return { mode: "json", content: JSON.parse(body) }
    } catch (e) {
      return { mode: "text", content: body }
    }
  }
  return { mode: "json", content: metadata }
}
